import React from "react"

function ProcessCard({ process }) {
    const quantityNumber = String(process.quantity ?? "").split(" ")[0]

    return (
        <div className="d-flex align-items-center justify-content-between p-3 bg-white border rounded mb-2">
            <div>
                <div className="fw-semibold text-dark">{process.species}</div>
                <div className="fs-6 text-secondary">{process.method}</div>
            </div>
            <div
                className="bg-dark rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                style={{ width: "2rem", height: "2rem" }}
            >
                <span className="text-white fs-6 fw-semibold">{quantityNumber}</span>
            </div>
        </div>
    )
}

export default function ProcessInformation({ orderDetails }) {
    return (
        <div className="card rounded shadow-sm h-100" style={{ backgroundColor: "#e0f7fa" }}>
            <div className="card-body p-4">
                <h2 className="fs-5 fw-semibold text-dark mb-3">Processing Details</h2>

                <div className="d-flex flex-column gap-2 mb-4">
                    {orderDetails.processes.map((process, index) => (
                        <ProcessCard key={index} process={process} />
                    ))}
                </div>

                <div className="d-flex flex-column gap-2 fs-6">
                    <div className="fw-semibold text-dark">
                        Depot Weight: {orderDetails.totalWeight} Lbs
                    </div>
                    <div className="fw-semibold text-dark">
                        Boxes / Bags: {orderDetails.numberOfContainers}
                    </div>
                </div>
            </div>
        </div>
    )
}
